import { computed, ref } from 'vue';
import { defineStore } from 'pinia';

export const useHubAuthStore = defineStore('hub-auth', () => {
	const accessToken = ref<string>();

	const isLoggedIn = computed(() => Boolean(accessToken.value));

	function setAccessToken(token: string): void {
		accessToken.value = token;
	}

	function clearAccessToken(): void {
		accessToken.value = undefined;
	}

	return {
		accessToken,
		isLoggedIn,
		setAccessToken,
		clearAccessToken,
	};
});
